import {Component, OnInit, inject} from '@angular/core';
import {AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule} from '@angular/forms';
import {I18nService} from '../../../_services/gui/i18n.service';
import {CompaniesService} from '../../../_services/data/companies.service';
import {NotificationService} from '../../../_services/gui/notification.service';
import {HttpResponse} from '@angular/common/http';
import {filter, tap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {Company} from '../../../_data/admin/company';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {exists, ofOr} from '../../../_utils/operators';
import {getStateFromRouter} from '../../../_utils/nav';
import {NgClass} from '@angular/common';
import {ValidationErrorsComponent} from '../../../common/forms/validation-errors/validation-errors.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-create-company',
    templateUrl: './create-company.component.html',
    styleUrls: ['./create-company.component.scss'],
    imports: [ReactiveFormsModule, NgClass, ValidationErrorsComponent, RouterLink, TranslateModule]
})
export class CreateCompanyComponent implements OnInit {

  companyNameParam: string;
  companyFailedToLoad = false;

  createCompanyFormGroup: UntypedFormGroup;
  formSubmitted: boolean = false;

  isEditing = false;

  protected i18nService = inject(I18nService);
  protected companiesService = inject(CompaniesService);
  private notificationService = inject(NotificationService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private originalCompanyName: string;

  constructor() {
    const formBuilder = inject(UntypedFormBuilder);


    this.i18nService.setTitle('title.admin.companies.create');
    this.createCompanyFormGroup = formBuilder.group({companyName: ['', Validators.required], ipBypass: false});

    this.route.data.pipe(exists(), filter(value => !!value.editing)).subscribe(() => {
      this.i18nService.setTitle('title.admin.companies.edit');
      this.isEditing = true;
      this.companyNameParam = this.route.snapshot.params.companyName;
      ofOr(
        getStateFromRouter(this.router),
        this.companiesService.getCompanyDetails(this.companyNameParam).pipe(tap(company => this.companyFailedToLoad = !company))
      ).subscribe((c: Company) => {
        console.debug(`Company loaded: ${JSON.stringify(c)}`);
        console.debug('Resetting form group...');
        // this.createCompanyFormGroup.setValue(CreateCompanyComponent.buildIdentificationFormGroup(c.companyName, c.bypassIPCheck === 1));
        this.originalCompanyName = c.companyName;
        this.createCompanyFormGroup.controls.companyName.setValue(c.companyName);
        this.createCompanyFormGroup.controls.ipBypass.setValue(c.bypassIPCheck === 1);
      });
    });

  }

  ngOnInit() {

  }

  submit(formValue: any): void {
    console.debug('Submitting company');
    this.formSubmitted = true;
    if(this.createCompanyFormGroup.valid) {
      let obs: Observable<HttpResponse<string>>;
      if(this.isEditing) {
        obs = this.companiesService.updateCompany(this.originalCompanyName, formValue.companyName, formValue.ipBypass ? 1 : 0);
      } else {
        obs = this.companiesService.addCompany(formValue.companyName, formValue.ipBypass ? 1 : 0);
      }
      obs.pipe(exists()).subscribe((data: HttpResponse<string>) => {
        if(data.status === 200) {
          console.debug('SUCCESS!! :-)');
          console.info('Automatically navigating to comapny details page');
          this.router.navigateByUrl(this.router.createUrlTree(['/admin/companies', formValue.companyName, 'details']));
        }
      });
    }
  }

  public get f(): UntypedFormGroup {
    return this.createCompanyFormGroup;
  }

  public get c(): {[p: string]: AbstractControl} {
    return this.createCompanyFormGroup.controls;
  }

}
